import './styles/app.less'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './icons' // icon
import './filters'
import './directives'
import './plugins'
import './permission'
import errorHandler from './errorHandler'
import globalComponents from './components'

Vue.config.productionTip = false
Vue.config.errorHandler = errorHandler

Object.keys(globalComponents).forEach(name => Vue.component(name, globalComponents[name]))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
